'use client';

import { Box, Flex, Image, useBreakpointValue } from '@chakra-ui/react';
import { useEffect } from 'react';
import { animate, scroll } from 'motion';
import { render } from 'datocms-structured-text-to-html-string';
import StructuredTextParser from '../../app/landing_pages/karma/Components/StructuredTextParser';
import SimpleButton from '@components/Buttons/SimpleButton';
import { mixPanel } from '@utils/Mixpanel';
import { useRegisterPopupVisibilityContext } from '@landing_pages/margazhi/context/registerPopupVisibilityContext';

export default function NamaskaramSection({ sectionContent, pageData }) {
  const { onOpen, isFaqOpen, isOpen, isLargeScreen } =
    useRegisterPopupVisibilityContext();
  const images = useBreakpointValue({
    base: sectionContent?.[0]?.mobileImages || sectionContent?.[0]?.images,
    sm: sectionContent?.[0]?.tabletImages || sectionContent?.[0]?.images,
    md: sectionContent?.[0]?.images,
  });
  useEffect(() => {
    const items = document.querySelectorAll('.left-image');
    const imageGroup = document.querySelectorAll('.image-group');
    if (imageGroup) {
      scroll(
        animate('.image-group', {
          transform: ['none', `translateY(-${(items.length - 1) * 100}vh)`],
        }),
        { target: document.querySelector('.image-group-container') }
      );
    }
  }, []);

  const mixPanelTrigger = () => {
    const Mixpanel = mixPanel(window?.location.pathname);
    Mixpanel.track('margazhi_register_now_cta_click', {
      cta: 'bottom cta',
      element: 'REGISTER NOW',
    });
  };

  const getContent = () => {
    return (
      <Box
        w={{ base: '100%', md: '50%' }}
        bg="#CF4520"
        color="white"
        display="flex"
        alignItems="flex-start"
        justifyContent="center"
        px={{
          base: '24px',
          md: isLargeScreen && (isOpen || isFaqOpen) ? '20px' : '60px',
          lg: isLargeScreen && (isOpen || isFaqOpen) ? '40px' : '104px',
        }}
        py={{ base: '70px', md: '10px' }}
        position="sticky"
        top="0"
        h={{ base: 'max-content', md: '100vh' }}
        flexDirection={'column'}
      >
        <StructuredTextParser
          str={render(sectionContent?.[1]?.body)}
          color="#FFF"
          sectionContent={sectionContent}
          fontSize={{ base: '20px', md: '24px' }}
          lineHeight={{ base: '28px', md: '36px' }}
          fontFamily="FedraSansStd-book"
          pb={{ base: '32px', md: '40px' }}
          letterSpacing={{ base: '0.4px', md: '0' }}
          maxW={{ base: '100%', md: '481px' }}
          mt="0"
        />
        <SimpleButton
          scrollPage={false}
          w={'max-content'}
          minW={{ base: '216px', lg: '305px' }}
          background={'#fff !important'}
          h={{ base: '54px' }}
          textAlign="center"
          mb={'0'}
          mt={'0'}
          mx={{ base: '0', md: '0' }}
          _hover={{
            background: '#AB3312 !important',
            color: '#fff',
          }}
          borderRadius={'4px !important'}
          style={{
            ...sectionContent?.[2],
            linkUrl: '',
            buttonText: (
              <Box
                justifyContent={'center'}
                display="flex"
                alignItems="center"
                gap="8px"
                height={'34px'}
              >
                <Box
                  className="allSmallCase"
                  lineHeight={'20px'}
                  paddingBottom={'6px'}
                >
                  {sectionContent?.[2]?.buttonText}
                </Box>
              </Box>
            ),
          }}
          padding={{
            base: '10px 32px',
            lg: '10px',
          }}
          color={'#1D1A16'}
          fontSize={'22px'}
          fontWeight="bold"
          fontFamily="'FedraSansStd-book', sans-serif"
          letterSpacing={'2.88px'}
          zIndex={100}
          onClick={() => {
            mixPanelTrigger();
            onOpen();
          }}
          className="register-now-button"
          useBlankStringURLOnLink
        ></SimpleButton>
      </Box>
    );
  };

  const getImages = images => {
    return (
      !!images?.length &&
      images?.map((data, i) => (
        <Image
          key={i}
          src={data?.url}
          alt={`img-${i}`}
          className="left-image"
          w="100%"
          h={{ base: '33.33vh', md: '100vh' }}
          objectFit="cover"
          display="block"
        />
      ))
    );
  };

  return (
    <Box id="register-section" as="section" w={'100%'} position="relative">
      <Flex
        className="image-group-container"
        h={`${images?.length * 100}vh`} // enough scroll height
        position="relative"
        display={{ base: 'none', md: 'flex' }}
      >
        {/* Left - Images (scrolls vertically) */}
        <Box w={{ base: '100%', md: '50%' }} position="relative">
          <Box position="sticky" top="0" h="100vh" overflow="hidden">
            <Box className="image-group" h="100%">
              {getImages(images)}
            </Box>
          </Box>
        </Box>

        {getContent()}
      </Flex>
      <Box
        position="sticky"
        top="0"
        h="100vh"
        flex="1"
        flexDirection="column"
        display={{ base: 'flex', md: 'none' }}
      >
        {images.map((data, i) => (
          <Image
            key={i}
            src={data?.url}
            alt={`img-${i}`}
            w="100%"
            h="33.33vh"
            objectFit="cover"
            display="block"
          />
        ))}
      </Box>
      <Box display={{ base: 'flex', md: 'none' }}>{getContent()}</Box>
      <style jsx global>{`
        .allSmallCase {
          font-variant: all-small-caps;
        }
      `}</style>
    </Box>
  );
}
